import React from "react";
import { ResultPopupProp } from "./QuizTypes";
import { CancelButton, CorrectIcon, WrongIcon } from "./SVG";
import './Quiz.css';
import SadImage from '../../../assets/images/Sad.svg';
import GoodImage from '../../../assets/images/Good.png';
import { PrimaryButton } from "../../Modules/PrimaryButton";
const ResultPopup: React.FC<ResultPopupProp> = ({
    totalQuestions,
    correctQuestions,
    onContinue,
    buttonStyles,
    GeneralFunctions,
    setIsResultPopup,
    setQuiz,
    styleConfig,
    isQuizOverview,
    ResultPopupCloseIcon,
    onTryAgain,
    isQuizOverviewTitle,
    questionDetails,
    expectedCorrectedAnswers,
    yourScore
}) => {

    const QuizOverview = () => {
        return (
            <>
                {isQuizOverviewTitle && <p className="quiz-overview-title">Quiz Overview</p>}
                <div className="quiz-overview-cont">
                    {questionDetails?.map((question: any, index: number) => {
                        return (
                            <div className="quiz-overview-item" key={index}>
                                <p className="quiz-overview-item-title">{question.question}</p>
                                {question.isCorrectAnswer ? CorrectIcon() : WrongIcon()}
                            </div>
                        )
                    })}
                </div>
            </>
        )
    }

    return (
        <div className="thanks-popup-upper-div">
            <div
                className="quiz-thanks-pop-up"
                // style={themeManager.getThanksPopupStyles()}
                style={{ background: styleConfig?.ResultPopup?.background }}
            >
                {ResultPopupCloseIcon && <div className="quiz-pop-up-cancel-btn-cont">
                    <div>
                        <div
                            onClick={() => {
                                GeneralFunctions.fireTrackingEvent(
                                    "quest_quiz_feedback_close_button_clicked",
                                    "quiz"
                                );
                                setQuiz(false);
                                setIsResultPopup(false);
                            }}
                        // style={themeManager.getThanksPopUpFooterStyles()}
                        >
                            {CancelButton(styleConfig?.IconColor?.color)}
                        </div>
                    </div>
                </div>}

                {expectedCorrectedAnswers === true ? <div className="quiz-pop-up-message-cont">
                    <img src={styleConfig?.ResultPopupImage?.passed || GoodImage} alt="" className="quiz-pop-up-image" />
                    <div className="pop-up-message">
                        <p className="pop-up-message-heading">{styleConfig?.ResultPopupHeading?.passed || 'Congratulations!'}</p>
                        <p className="pop-up-message-para">{styleConfig?.ResultPopupDescription?.passed || 'You’ve successfully completed the quiz.'}</p>
                        <p className="pop-up-message-scores">
                            {yourScore}: <span>{correctQuestions}/{totalQuestions}</span>
                        </p>
                    </div>
                    {isQuizOverview && <QuizOverview />}
                    <PrimaryButton
                        type={"button"}
                        onClick={() => {
                            onContinue();
                        }}
                        className="q-onb-main-btn2"
                        style={{
                            font: "",
                            fontFamily: "Figtree",
                            background:
                                buttonStyles?.background ||
                                "linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%)",
                            color:
                                buttonStyles?.color ||
                                "var(--Neutral-White-100, #FFF)",

                            border: `1.5px solid ${buttonStyles?.borderColor ? buttonStyles?.borderColor : "#D1ACFF"}`,
                            fontStyle: "normal",
                            fontWeight: "600",
                            lineHeight: "20px",
                            ...buttonStyles
                        }}
                    >
                        {styleConfig?.ResultPopupButtonText?.passed || 'Continue'}
                    </PrimaryButton>
                </div> : <div className="quiz-pop-up-message-cont">
                    <img src={styleConfig?.ResultPopupImage?.failed || SadImage} alt="" className="quiz-pop-up-image" />
                    <div className="pop-up-message">
                        <p className="pop-up-message-heading">{styleConfig?.ResultPopupHeading?.failed || 'Not this time..'}</p>
                        <p className="pop-up-message-para">{styleConfig?.ResultPopupDescription?.failed || 'You did not reach the required minimum score.'}</p>
                        <p className="pop-up-message-scores">
                            {yourScore}: <span>{correctQuestions}/{totalQuestions}</span>
                        </p>
                    </div>
                    {isQuizOverview && <QuizOverview />}
                    <PrimaryButton
                        type={"button"}
                        onClick={() => {
                            onTryAgain();
                        }}
                        className="q-onb-main-btn2"
                        style={{
                            font: "",
                            fontFamily: "Figtree",
                            background:
                                buttonStyles?.background ||
                                "linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%)",
                            color:
                                buttonStyles?.color ||
                                "var(--Neutral-White-100, #FFF)",

                            border: `1.5px solid ${buttonStyles?.borderColor ? buttonStyles?.borderColor : "#D1ACFF"}`,
                            fontStyle: "normal",
                            fontWeight: "600",
                            lineHeight: "20px",
                            ...buttonStyles
                        }}
                    >
                        {styleConfig?.ResultPopupButtonText?.failed || 'Try Again'}
                    </PrimaryButton>
                </div>}
            </div>
        </div>
    );
};

export default ResultPopup;
